import { useScreen } from '@/hooks/useScreen';
import useToggle from '@/hooks/useToggle';
import { Button } from 'design-system/components/Button';
import { Typography } from 'design-system/components/Typography';
import dynamic from 'next/dynamic';
import { useState } from 'react';

const Popover = dynamic(() => import('@mui/material/Popover'));
const DropdownRow = dynamic(
  () => import('design-system/components/Dropdown/DropdownRow')
);
const DynamicModalAddDocument = dynamic(
  () =>
    import(
      '@/components/elements/doccen-lib/collection-detail/modal/ModalAddDocument'
    )
);
const ModalUpsertExternalDocument = dynamic(
  () => import('../modal/ModalUpsertExternalDocument')
);

const AddDocumentToCollectionButton = ({
  collectionId,
}: {
  collectionId: string;
}) => {
  const { isMobile } = useScreen();
  const [openAddDocumentModal, togglAddDocumentModal] = useToggle();
  const [openAddExternalDocumentModal, togglAddExternalDocumentModal] =
    useToggle();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        size={isMobile ? 'small' : 'medium'}
        startIcon={{
          name: 'add',
        }}
        className="whitespace-nowrap"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        Thêm tài liệu
      </Button>
      {open && (
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          slotProps={{
            paper: {
              className:
                '!rounded-[10px] !shadow-elevator2 space-y-1 py-2 min-w-[176px]',
            },
          }}
        >
          <>
            <DropdownRow onClick={togglAddDocumentModal}>
              <Typography variant="display3">Tài liệu</Typography>
            </DropdownRow>

            <DropdownRow onClick={togglAddExternalDocumentModal}>
              <Typography variant="display3">Nội dung khác</Typography>
            </DropdownRow>
          </>
        </Popover>
      )}

      {openAddDocumentModal && (
        <DynamicModalAddDocument
          id={collectionId}
          open={openAddDocumentModal}
          onClose={togglAddDocumentModal}
        />
      )}

      {openAddExternalDocumentModal && (
        <ModalUpsertExternalDocument
          collectionId={collectionId}
          open={openAddExternalDocumentModal}
          onClose={togglAddExternalDocumentModal}
        />
      )}
    </>
  );
};

export default AddDocumentToCollectionButton;
